import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
import { tokenConfig } from "../tokenConfig";

// Get Notification
export const getNotification = createAsyncThunk(
  "notification/all",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get("/admin/notifications", config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Notification Count
export const getNotificationCount = createAsyncThunk(
    "notification/count",
    async (_, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.get("/admin/notifications-unread-count", config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  //Delete All Notifications
  export const deleteAllNotifications = createAsyncThunk(
    "notification/delete-all",
    async (_, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.delete("/admin/notifications", config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    loading: false,
    notifications: [],
    count: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //get-notification
      .addCase(getNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
      })
      .addCase(getNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       //get-notification-count
       .addCase(getNotificationCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotificationCount.fulfilled, (state, action) => {
        state.loading = false;
        state.count = action.payload.data;
      })
      .addCase(getNotificationCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //delete-all-notifications
      .addCase(deleteAllNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAllNotifications.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAllNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default notificationSlice.reducer;
